import React, { Component } from 'react';

class Home extends Component {
	render() {
		return (
			<>
				<h2>
					Vitajte!
				</h2>
				<p className='font-size-20'>
					Vítame Vás na stránkach spoločnosti PROGRES PLUS, s.r.o. , dúfame, že budete s našími službami spokojný a nájdete všetky potrebné informácie
				</p>
				<h3>
					O nás
				</h3>
				<p className='font-size-20 text-align--justify'>
					Firma PROGRES PLUS, s.r.o. je činná na trhu už 14 rokov, teda patrí už k starším obchodným firmám. V súčasnosti sa firma venuje hlavne maloobchodnému predaju pohonných hmôt (nafta, benzín), venuje sa výstavbe  čerpacích staníc, včetne samoobslužných terminálov. Zrealizovali sme už niekoľko desiatok čerpacích staníc na Slovensku s obsluhou i bez obsluhy.
					Najnovšou činnosťou firmy bude predaj motorových ručne vedených vozíkov z Veľkej Británie tzv. „Muck-Truck“, na ktorých predaj získala firma výhradné zastúpenie pre Česko a Slovensko s výnimkou Prahy. Je to unikátny produkt, ktorý uľahčí a maximálne zefektívni prácu v rôznych oblastiach ľudských činností (stavebníctvo, poľnohospodárstvo, logistika, zemné práce, technické služby  a iné). Veríme, že naši klienti, budúci majitelia tohto produktu budú maximálne spokojní.
				</p>
			</>
		);
	}
}

export default Home;
